import nextAction from 'model/actions/utilities/nextAction';

const end = onDone => ({
  title: 'McKenzie Brothers',
  description: [
    'One of the brothers climbs the rope, kicks out the bars and rappels down. The other right behind him. ',
    'They dash for a nearby corral and mount a couple of horses. ',
    'The commotion causes plenty of noise and a deputy comes to investigate. He raises the alarm when he sees the jail empty and the brothers riding off',
    'A posse is formed to chase them. Last I hear, the brothers made it to open country and freedom.'
  ],
  buttons: [nextAction('OK', onDone(end(onDone)))]
});

const breakout = onDone => ({
  title: 'McKenzie Brothers',
  description: [
    'I decide these men are innocent and help them break out. ',
    'I secure a rope to the tree and throw it through the window and into the jailhouse. Then I move a safe distance away.',
    "If I'm wrong and these men are criminals, they might not want witnesses to their escape. And if they get caught, I don't want them outing me as their accomplice.",
    "It's best to watch from a distance."
  ],
  buttons: [nextAction('Watch', onDone(end(onDone)))]
});

const arrest = onDone => ({
  title: 'McKenzie Brothers',
  description: [
    'they finally caught up to them in this town. ',
    'they were trying to befriend the fiends and earn their confidence so they could shoot or arrest them and claim the bounty on their heads.',
    'they gained their confidence and were supposed to leave together. but looks like the outlaws got suspicious and left town early.',
    "the townspeople then mistakenly assumed they were part of the gang. And now they'll hang.",
    'their story sounds unlikely, but their voices are those of earnest men.'
  ],
  buttons: [nextAction('I believe them', () => onDone(breakout(onDone)))]
});

const story = onDone => ({
  title: 'McKenzie Brothers',
  description: [
    'they were riding through the woods near their home. heard screams and gunshots so they went to investigate',
    'as they got near, they saw a caravan in flames. bodies everywhere. women... children... everyone dead. ',
    'a pack of bandits quickly riding off',
    'they spent the next hours trying to rend aid and comforting the dying. then decided to chase the bandits.'
  ],
  buttons: [nextAction('Then what?', () => onDone(arrest(onDone)))]
});

const jail = onDone => ({
  title: 'McKenzie Brothers',
  description: [
    'at night I skulk by the jail. the window is high. too high to climb. but the bars are old and rusted.',
    "with a hushed voice, I try to get some answers. are these really bloodthrirsty bandits? what's their involvement with the caravan?",
    'they tell me their story'
  ],
  buttons: [nextAction('Listen', () => onDone(story(onDone)))]
});

const start = onDone => ({
  title: 'McKenzie Brothers',
  description: [
    'a big commotion in town. two brothers woken from their drunken stupor with ropes around their necks.',
    'part of a big gang that recently massacred a caravan - My caravan?',
    'sherif stopped the lynching and calmed the mood. brought them to jail to await trial.'
  ],
  buttons: [nextAction('Approach jail', () => onDone(jail(onDone)))]
});

export default start;
